import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SelectionRangeStats } from '../../../../models/selection-range-stats';

@Component({
  selector: 'y42-table-footer',
  templateUrl: './table-footer.component.html',
  styleUrls: ['./table-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFooterComponent implements OnInit {
  @Input() rows?: number;
  @Input() columnsLength?: number;
  @Input() size?: string;
  @Input() previewRows?: number;
  @Input() showSize?: boolean;
  @Input() showPreviewRow = true;
  @Input() cellRangesStats: SelectionRangeStats = {
    avg: null,
    sum: null,
    count: null,
    selected: 0,
  };
  previewToolTip = '';

  ngOnInit(): void {
    this.previewToolTip =
      this.rows && this.previewRows && this.rows > this.previewRows
        ? `For performance purposes, we only load the first ${this.previewRows} rows for the preview`
        : '';
  }
}
